import { render, staticRenderFns } from "./BlockedCandidates.vue?vue&type=template&id=fb54077e&scoped=true"
import script from "./BlockedCandidates.vue?vue&type=script&lang=js"
export * from "./BlockedCandidates.vue?vue&type=script&lang=js"
import style0 from "./BlockedCandidates.vue?vue&type=style&index=0&id=fb54077e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb54077e",
  null
  
)

export default component.exports